import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-82 (BU-10e) — provision a portal user (turn a Forecast contact into a portal login).
 * Proxies through graphql/ to the portal internal admin API (no forecast_db write).
 */
const mutation = graphql`
	mutation provisionPortalUserMutation($input: ProvisionPortalUserInput!) {
		provisionPortalUser(input: $input) {
			portalUsers {
				id
				email
				clientContactId
				roleKey
				status
				scopeLevel
				scopeProgrammeIds
				scopeProjectIds
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
